/**
 * N% 이상 매칭용 짧은 정규식 조각 생성 (뒤에 % 포함)
 * @param {string|number} num
 * @returns {string}
 */
export const regexCalc = (num) => {
  const n = Number(num);

  if (n < 10 || isNaN(n)) {
    return "";
  }

  // 1000 이상은 1...% 로 고정
  if (n >= 1000) {
    return "1...%";
  }

  // 100-999
  if (n >= 100) {
    const hundreds = Math.floor(n / 100);
    const tens = Math.floor((n % 100) / 10);
    const ones = n % 10;

    // 100, 200, 300 ...
    if (tens === 0 && ones === 0) {
      if (hundreds === 1) {
        return "(1..|[2-9]..)%";
      }
      if (hundreds === 9) {
        return "(9..)%";
      }
      return `([${hundreds}-9]..)%`;
    }

    // 105, 207 ...
    if (tens === 0) {
      if (hundreds === 1) {
        return `(10[${ones}-9]|1[1-9].|[2-9]..)%`;
      }
      if (hundreds === 9) {
        return `(90[${ones}-9]|9[1-9].)%`;
      }
      return `(${hundreds}0[${ones}-9]|${hundreds}[1-9].|[${hundreds + 1}-9]..)%`;
    }

    // 120, 230 ...
    if (ones === 0) {
      if (hundreds === 1) {
        return `(1[${tens}-9].|[2-9]..)%`;
      }
      if (hundreds === 9) {
        return `(9[${tens}-9].)%`;
      }
      return `(${hundreds}[${tens}-9].|[${hundreds + 1}-9]..)%`;
    }

    // 123, 191, 456 ... (tens === 9 이면 tens+1 항 생략)
    if (hundreds === 1) {
      if (tens === 9) {
        return `(19[${ones}-9]|[2-9]..)%`;
      }
      return `(1${tens}[${ones}-9]|1[${tens + 1}-9].|[2-9]..)%`;
    }
    if (hundreds === 9) {
      if (tens === 9) {
        return `(99[${ones}-9])%`;
      }
      return `(9${tens}[${ones}-9]|9[${tens + 1}-9].)%`;
    }
    if (tens === 9) {
      return `(${hundreds}9[${ones}-9]|[${hundreds + 1}-9]..)%`;
    }
    return `(${hundreds}${tens}[${ones}-9]|${hundreds}[${tens + 1}-9].|[${hundreds + 1}-9]..)%`;
  }

  // 10-99
  const tens = Math.floor(n / 10);
  const ones = n % 10;

  // 10, 20, 90
  if (ones === 0) {
    if (tens === 9) {
      return "(9.|[1-9]..)%";
    }
    return `([${tens}-9].|[1-9]..)%`;
  }

  // 19, 29, 99
  if (ones === 9) {
    if (tens === 9) {
      return "(99|[1-9]..)%";
    }
    if (tens === 8) {
      return "(89|9.|[1-9]..)%";
    }
    return `(${tens}9|[${tens + 1}-9].|[1-9]..)%`;
  }

  // 15, 34, 67
  if (tens === 9) {
    return `(9[${ones}-9]|[1-9]..)%`;
  }
  if (tens === 8) {
    return `(8[${ones}-9]|9.|[1-9]..)%`;
  }
  return `(${tens}[${ones}-9]|[${tens + 1}-9].|[1-9]..)%`;
};
